import { createContext, useContext, useEffect, useRef } from 'react';

/** Back navigation shared with screens (see hooks/useAppHistory) */
export const NavigationContext = createContext({ back: () => window.history.back(), registerBackHandler: () => () => {} });

export const useNavigation = () => useContext(NavigationContext);

/**
 * Let Back close an inner layer before leaving the screen.
 *   useBackHandler(isOpen, close)   while `isOpen`, a Back press calls `close()` instead of leaving
 */
export const useBackHandler = (isOpen, close) => {
  const { registerBackHandler } = useNavigation();
  // Register once per open; the latest `close` is read through a ref so a new function identity
  // on each render does not churn the registration (which could land mid-Back on the wrong entry)
  const closeRef = useRef(close);
  closeRef.current = close;
  useEffect(() => {
    if (!isOpen) return undefined;
    return registerBackHandler(() => { closeRef.current(); return true; });
  }, [isOpen, registerBackHandler]);
};
